import { PGlite } from '@electric-sql/pglite';
import { PgliteDatabase } from 'drizzle-orm/pglite';
import { createContext } from 'react';

interface DbContextType {
    db: PgliteDatabase<Record<string, never>> & {
        $client: PGlite;
    }
}
export const DbContext = createContext<DbContextType | undefined>(undefined);